module.exports = __webpack_public_path__ + "static/media/mergeCardsSmall.fdc731aa.svg";